<div class="glassy-table card-nav-tabs mt-0 rounded-lg border-0 container p-4 shadow">

    <div class="mb-4 d-none">
        <label for="trust_type" class="form-label text-xxs">Select Entity Type</label>
        <select id="trust_type" class="form-select text-xxs rounded-3 shadow-sm" v-model="selected_trust_type">
          <option disabled hidden=""></option>
          <option value="family">Family Trust</option>
          <option value="unit">Unit Trust</option>
          <option value="discretionary">Discretionary Trust</option>
        </select>
    </div>

    <p class="text-xxs mb-2 mt-3 fw-bold">Send Forms to Client</p>
    <div class="table-responsive mt-3">
      <table class="table table-hover">
        <thead class="custom-header">
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Select</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Form Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Form Description</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="form in forms" :key="form.id">
            <td class="text-xxs text-start">
              <div class="form-check d-flex justify-content-center">
                <input class="form-check-input" type="checkbox" v-model="form.selected">
              </div>
            </td>
            <td class="text-xxs text-start">{{ form.name }}</td>
            <td class="text-xxs text-start">{{ form.form_description || '—' }}</td>
            <td class="text-xxs text-start">
              <button
                class="btn btn-primary-dark btn-sm text-xxs"
                @click="view_form(form)"
                data-bs-toggle="modal" data-bs-target="#view_form"
              >
                View
              </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex align-items-center gap-3 mt-3">
      <button class="btn btn-primary-dark btn-sm text-xxs" @click="send_selected">
        Send Selected Forms
      </button>
    </div>

<teleport to="body">
  <div class="modal fade" id="view_form" tabindex="-1" aria-labelledby="view_form_label" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs" id="view_form_label">
            Preview: {{ preview_form.form_name }}
          </h5>
          <button
            type="button"
            class="btn-close modal-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body contract-scrollable">
          <div
            v-for="(preview_section, si) in preview_form.sections" 
            :key="preview_section.id" 
            class="mb-3"
          >
            <!-- Section Header (Clickable) -->
            <div class="glassy-table border-0 border-1 rounded-lg mb-2 p-3 shadow">
              <div 
                class="section-header text-x fw-bold d-flex justify-content-between align-items-center border-bottom border-2 pb-2 mb-3"
                @click="toggle_preview_section(si)"
                style="cursor: pointer;"
              >
                <!-- Section Name -->
                <span class="text-capitalize">{{ preview_section.name }}</span>
                
                <!-- Chevron Icon -->
                <i :class="is_preview_section_open(si) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
              </div>

              <!-- Questions (Collapsible) -->
              <div v-if="is_preview_section_open(si)">
                <template v-for="(question, qi) in preview_section.questions" :key="question.id">
                  <!-- Question Label -->
                  <div class="d-flex justify-content-between align-items-start mt-1">
                    <div class="d-flex flex-grow-1">
                      <span class="text-xs fw-7 me-1">{{ qi + 1 }}.</span>
                      <label class="flex-grow-1 text-dark text-xs text-capitalize fw-7">
                        {{ question.question_text }}
                      </label>
                    </div>
                  </div>

                  <!-- Question Input -->
                  <div class="mb-3 ms-2">
                    <!-- Text/Number -->
                    <input
                      v-if="['short_text', 'long_text', 'number'].includes(question.question_type.question_type)"
                      type="text"
                      class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg"
                      :placeholder="'Enter ' + question.question_text"
                    />

                    <!-- Date -->
                    <input
                      v-else-if="question.question_type.question_type === 'date'"
                      type="date"
                      class="form-control form-control-sm text-xxs bg-white border py-1 rounded-lg"
                    />

                    <!-- Single Select (Radio) -->
                    <div v-else-if="question.question_type.question_type === 'single_select'" class="radio-group">
                      <div 
                        v-for="opt in (question.multi_select_choices || question.options || [])"
                        :key="opt.id || opt"
                        class="form-check"
                      >
                        <input 
                          class="form-check-input" 
                          type="radio" 
                          :name="`question_${question.id}`"
                          :id="`choice_${opt.id || opt}`"
                        />
                        <label class="form-check-label text-xxs" :for="`choice_${opt.id || opt}`">
                          {{ typeof opt === 'object' ? opt.choice : opt }}
                        </label>
                      </div>
                    </div>

                    <!-- Multi Select (Checkbox) -->
                    <div v-else-if="question.question_type.question_type === 'multi_select'">
                      <div 
                        v-for="opt in (question.multi_select_choices || question.options || [])"
                        :key="opt.id || opt"
                        class="form-check"
                      >
                        <input 
                          class="form-check-input" 
                          type="checkbox" 
                          :id="`choice_${opt.id || opt}`"
                        />
                        <label class="form-check-label text-xxs" :for="`choice_${opt.id || opt}`">
                          {{ typeof opt === 'object' ? opt.choice : opt }}
                        </label>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

</div>
